import Link from 'next/link';

import { Button, type ButtonProps } from '@rockalingua/ui';

import { analyticsEvents } from '@/components/analytics/constants/analytics';
import trackEvent from '@/components/analytics/plausible/trackEvent';
import useSignUpHref from '@/domains/marketing/hooks/useSignUpHref';
import { StyledLink } from './SignUpButton.styled';

export default function SignUpButton(buttonProps: ButtonProps) {
  const signUpHref = useSignUpHref();

  const handleClick = () => {
    trackEvent(analyticsEvents.freeTrialButtonClick);
  };

  return (
    <StyledLink href={signUpHref}>
      <Button
        {...buttonProps}
        onClick={handleClick}
        size="large"
        type="primary"
      />
    </StyledLink>
  );
}
